/**
 * @file Modale "Pendant ton absence" : duree, plafond atteint, argent gagne, arbres abattus, reclamer (x1 ou x2 contre gemmes).
 */
import { formatBig, formatDuration } from '@shared/format';
import { Component } from '../core/Component';
import { h, setText, toggleClass } from '../core/dom';
import { send } from '../core/feedback';
import { amountChip } from '../core/widgets';
import type { UiContext } from '../UiContext';

/** Cout du "x2" (affichage : le prix reel est applique par OfflineService.claim). */
const DOUBLE_COST_DIA = 20;

export class OfflineModal extends Component {
  private claimBtn!: HTMLButtonElement;
  private doubleBtn!: HTMLButtonElement;
  private done = false;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'modal offline');
  }

  protected build(): void {
    const t = this.ctx.i18n;
    const report = this.ctx.sim.query.offline();
    this.el.setAttribute('data-ui-block', '');
    this.el.setAttribute('role', 'dialog');
    this.el.setAttribute('aria-modal', 'true');

    const lines = h('div', { class: 'offline-lines' });
    if (report) {
      lines.append(h('p', { class: 'offline-duration' }, t.t('offline.duration', { time: formatDuration(report.awaySeconds) })));
      if (report.capped) lines.append(h('p', { class: 'offline-capped' }, t.t('offline.capped')));
      lines.append(
        h('div', { class: 'offline-earned' }, amountChip('money', report.money), h('span', { class: 'offline-earned-text' }, t.t('offline.earned', { money: formatBig(report.money) }))),
        h('p', { class: 'offline-kills' }, t.t('offline.kills', { kills: formatBig(report.kills) })),
      );
    }

    this.claimBtn = h('button', { class: 'btn primary big', type: 'button', onclick: () => this.claim(false) }, t.t('common.claim'));
    this.doubleBtn = h('button', { class: 'btn gem big', type: 'button', onclick: () => this.claim(true) }, t.t('offline.double', { cost: DOUBLE_COST_DIA }));
    this.el.append(h('div', { class: 'dialog panel' }, h('h2', { class: 'dialog-title' }, t.t('offline.title')), lines, h('div', { class: 'dialog-actions column' }, this.claimBtn, this.doubleBtn)));
    this.update(0);
  }

  private claim(double: boolean): void {
    if (this.done) return;
    const r = send(this.ctx, { type: 'offline.claim', doubleWithDia: double });
    if (!r.ok) return;
    this.done = true;
    this.claimBtn.disabled = true;
    this.doubleBtn.disabled = true;
    this.ctx.sfx('coin');
    // UiApp retire la modale des que le rapport n'est plus en attente.
  }

  override update(_dt: number): void {
    const poor = this.ctx.sim.data.wallet.dia.lt(DOUBLE_COST_DIA);
    toggleClass(this.doubleBtn, 'disabled', poor);
    if (this.done) setText(this.claimBtn, this.ctx.i18n.t('common.claimed'));
  }
}
